
export const REPORTS_PATH = '/reports'

export default {
  REPORTS_PATH,
}
